import apiService from "./apiService";
import AppConstants from "../appConstants";

class VersionService {
    getBackendVersion(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_VERSION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new VersionService();
